import * as React from "react";
import { ArrowsRightLeftIcon, DocumentTextIcon, QuestionMarkCircleIcon, UsersIcon } from "@heroicons/react/24/outline";
import { ClientRow } from "../../models.ts";

interface Props {
    clientReports: ClientRow[];
}

export function DashboardKpiSubtitle({ clientReports }: Props) {
    const clientCount = clientReports.length;

    const totalTransactions = clientReports.reduce(
        (sum, report) => sum + (report.transactions_count ?? 0),
        0
    );
    const totalVraagposten = clientReports.reduce((sum, report) => sum + (report.mdr_count ?? 0), 0);
    const totalDocuments = clientReports.reduce((sum, report) => sum + (report.documents_uploaded_count ?? 0), 0);

    const stats = [
        { Icon: UsersIcon, value: `${clientCount}`, label: "klanten" },
        { Icon: ArrowsRightLeftIcon, value: `${totalTransactions}`, label: "transacties" },
        { Icon: QuestionMarkCircleIcon, value: `${totalVraagposten}`, label: "vraagposten" },
        { Icon: DocumentTextIcon, value: `${totalDocuments}`, label: "documenten" },
    ];

    return (
        <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-sm text-gray-500">
            {stats.map(({ Icon, value, label }, index) => (
                <React.Fragment key={label}>
                    {index > 0 && <span className="text-gray-300">·</span>}
                    <span className="inline-flex items-center gap-1.5">
                        <Icon className="h-5 w-5 text-gray-400" />
                        <span className="font-semibold text-gray-800">{value}</span>
                        {label}
                    </span>
                </React.Fragment>
            ))}
        </div>
    );
}
